import { render, staticRenderFns } from "./UpdateProspect.vue?vue&type=template&id=09c86621&scoped=true"
import script from "./UpdateProspect.vue?vue&type=script&lang=js"
export * from "./UpdateProspect.vue?vue&type=script&lang=js"
import style0 from "./UpdateProspect.vue?vue&type=style&index=0&id=09c86621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c86621",
  null
  
)

export default component.exports